import { CyberPanel } from "@/components/ui/CyberPanel";
import { IconRenderer } from "@/components/icons/IconRenderer";
import { SEO } from "@/components/seo/SEO";
import { usePublicSocialLinks } from "@/features/social-links/hooks";
import { PublicError, PublicLoading, PublicEmpty } from "@/pages/public/PublicState";

export function SocialsPage() {
  const socials = usePublicSocialLinks();
  if (socials.isLoading) return <PublicLoading />;
  if (socials.isError) return <PublicError />;
  if (!socials.data?.length) return <PublicEmpty title="Socials" description="No active social links are published yet." />;

  return (
    <section className="mx-auto w-full max-w-7xl px-3 py-8 sm:px-6 sm:py-16 lg:px-8">
      <SEO title="Socials" description="Connect with Kalaco on active social platforms." />
      <CyberPanel>
        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-teal-200 sm:text-sm sm:tracking-[0.28em]">Socials</p>
        <h1 className="mt-3 font-display text-3xl font-bold uppercase text-white sm:text-4xl">Connect</h1>
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {socials.data.map((link) => (
            <a key={link.id} href={link.url} target="_blank" rel="noreferrer" className="min-w-0 rounded-md border border-cyan-300/20 bg-black/30 p-4 transition hover:border-cyan-300/60 hover:shadow-neon sm:p-5">
              <span className="grid size-12 place-items-center rounded-md border border-cyan-300/25 bg-cyan-300/10 text-xl text-cyan-100">
                <IconRenderer value={link.iconName} iconSet="social" />
              </span>
              <p className="break-words font-display text-lg font-semibold uppercase text-white sm:text-xl">{link.label || link.platform}</p>
              <p className="mt-2 break-words text-sm text-cyan-100">{link.platform}</p>
            </a>
          ))}
        </div>
      </CyberPanel>
    </section>
  );
}
